import { createContext, useContext, useEffect, useReducer, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { FETCH_LLM_CONFIGS } from '@/actions/types';
import { setErrorMessage } from '@/actions/errorMessage';
import { fetchLlmConfigs } from '@/actions/llmConfigs';

const LlmConfigsContext = createContext(null);
const LlmConfigsDispatchContext = createContext(null);

const initial_state = null;

function llmConfigsReducer(state, action) {
  switch (action.type) {
    case FETCH_LLM_CONFIGS: {
      return action.payload;
    }
    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
}

export function LlmConfigsProvider({ children }) {
  const [llm_configs, llm_configs_dispatch] = useReducer(
    llmConfigsReducer,
    initial_state,
  );
  const dispatch = useDispatch();
  const fetched_ref = useRef(false);

  useEffect(() => {
    if (fetched_ref.current) return;
    fetched_ref.current = true;

    fetchLlmConfigs()
      .then((configs) => {
        llm_configs_dispatch({ type: FETCH_LLM_CONFIGS, payload: configs });
      })
      .catch((error) => {
        dispatch(setErrorMessage(error?.message || 'API Error'));
      });
  }, [dispatch]);

  return (
    <LlmConfigsContext.Provider value={llm_configs}>
      <LlmConfigsDispatchContext.Provider value={llm_configs_dispatch}>
        {children}
      </LlmConfigsDispatchContext.Provider>
    </LlmConfigsContext.Provider>
  );
}

export function useLlmConfigs() {
  return useContext(LlmConfigsContext);
}

export function useLlmConfigsDispatch() {
  const dispatch = useContext(LlmConfigsDispatchContext);
  if (!dispatch) {
    throw new Error('useLlmConfigsDispatch must be used within LlmConfigsProvider');
  }
  return dispatch;
}

